import { $Q } from './query-selector';

/**
 * Open nodes with CSS and dataset
 * @param {String} node selector who detect click
 * @param {String} query selector with the node to open
 * @param {Object} config Obejct with attribute from config open
 *
 * @return {Function}
 */

export const toggleDataActive = (node, parent, config) => {
  const { overlay } = config ? config : { overlay: false };
  const toOpen = parent ? $Q(parent) : $Q(node);

  if(!$Q(node)) return;

  return $Q(node).addEventListener(
    'click',
    function () {
      dataToggle(toOpen, overlay)
    }
  )
}

export function dataToggle (nodeToOpen, overlay) {
  const dataset = nodeToOpen.dataset.active
  const isActive = dataset != 'true' ? false : true

  if (!dataset) return null

  if (!isActive) {
    nodeToOpen.dataset.active = 'true';
  } else {
    nodeToOpen.dataset.active = 'false';
  }

  overlay && overlayActions({
    isActive,
    target: nodeToOpen
  })
}

const overlayActions = ({ isActive, target }) => {
  const id = target.getAttribute('id');

  const before = document.createElement('div');
  if (!isActive) {
    before.setAttribute('id', `overlay--${id}`);
    before.classList.add('overlay');
    target.parentNode.insertBefore(before, target);
    toggleDataActive(`#overlay--${id}`, `#${id}`, { overlay: true });

    setTimeout(() => {
      before.classList.add('fade');
    }, 150);
  } else {
    if(!$Q(`#overlay--${id}`)) return;

    $Q(`#overlay--${id}`).classList.remove('fade');

    setTimeout(() => {
      target.parentNode.removeChild($Q(`#overlay--${id}`));
    }, 250);
  }
};

export function simpleDataToggle(el) {
  el.dataset.active === 'true'
    ? el.setAttribute('data-active', 'false')
    : el.setAttribute('data-active', 'true');
}

export function toggleAriaBusy(el) {
  el.ariaBusy === 'true'
    ? el.setAttribute('aria-busy', 'false')
    : el.setAttribute('aria-busy', 'true');
}